<template>
  <div>
    <a-table
      :columns="columns"
      :rowKey="(record) => record.id"
      :dataSource="problems"
      :loading="similarCompLoading"
      :locale="mylocale"
    >
      <template slot="cover" slot-scope="record">
        <problem-cover-col :problem="record"></problem-cover-col>
      </template>

      <template slot="number" slot-scope="record">
        {{ record.number.pad(6) }}
      </template>

      <template slot="address" slot-scope="record">
        <p>
          {{ record.executive.region.name }}
          <span v-if="record.street">,{{ record.street.name }}</span>
          <span v-if="record.address">,{{ record.address }}</span>
        </p>
      </template>

      <template slot="comptext" slot-scope="record">
        <span v-if="record.title">
          {{ record.title.substring(0, 200) }}

          <a-tooltip
            :title="record.title"
            v-if="record.title.length > 200"
            :overlayStyle="{ maxWidth: '500px' }"
          >
            <a-icon class="more-icon" type="small-dash" />
          </a-tooltip>
        </span>
      </template>

      <template slot="action" slot-scope="record">
        <a-button size="small" @click="compare(record)">Müqayisə et</a-button>

        <a-divider type="vertical" v-if="record.isCompleted" />

        <a-button size="small" @click="chooseDetail(record)">
          {{
            selectedProblem && selectedProblem.id == record.id
              ? "Ayır"
              : "Birləşdir"
          }}</a-button
        >

        <a-divider type="vertical" v-if="record.isCompleted" />
        <!--   <a-button size="small" v-if="record.isCompleted" @click="setPrevProblem(record)">Yenidən baş verib</a-button>
           <a-divider type="vertical" />-->
        <a-button size="small" href="javascript:;" @click="getDetailed(record)">
          Ətraflı
        </a-button>
      </template>
    </a-table>

    <detail-modal
      :visible="detailModalVis"
      :problemOb="detailedProblem"
      @afterClose="handleModalClose"
    ></detail-modal>
  </div>
</template>

<script>
import DetailModal from "@/components/pages/Modals/DetailModal/index";
import mixin from "@/mixins/index";
import { URL, apiCall } from "@/utils/api";
import ProblemCoverCol from "@/components/partials/ProblemCoverCol";

let  columns = [
  { key: "cover", scopedSlots: { customRender: "cover" }, width: "13%" },
  {
    title: "Mətn",
    key: "text",
    scopedSlots: { customRender: "comptext" },
    width: "27%",
  },
  {
    title: "Ünvan",
    key: "address",
    scopedSlots: { customRender: "address" },
    width: "25%",
  },
  {
    title: "Müraciət tarixi",
    key: "date",
    dataIndex: "appealDate",
    width: "15%",
  },
  { key: "action", scopedSlots: { customRender: "action" }, width: "20%" },
];

export default {
  name: "NearProblemsTable",
  mixins: [mixin],
  props: {
    distance: Number,
    latitude: Number,
    longitude: Number,
    selected: Object,
    completed: Boolean,
  },
  components: {
    "detail-modal": DetailModal,
    "problem-cover-col": ProblemCoverCol,
  },
  data() {
    if (window.innerWidth<=1100) {
      columns = [
  

  {
    title: "Ünvan",
    key: "address",
    scopedSlots: { customRender: "address" },
    width: "35%",
  },
  {
    title: "Müraciət tarixi",
    key: "date",
    dataIndex: "appealDate",
    width: "20%",
  },
  { key: "action", scopedSlots: { customRender: "action" }, width: "20%" },
      ];
    }
    return {
      detailedProblem:null,
  
      columns,
      // selectedRowKeys: [],
      selectedProblem: null,
      detailModalVis: false,
      similarCompLoading: false,
      problems: [],
      exist: false,
      totalCount: 0,
    };
  },
  methods: {
    // onSelectChange(selectedRowKeys) {
    //   this.selectedRowKeys = selectedRowKeys;
    // },
    handleModalClose() {
      this.detailModalVis = false;
/*       this.selectedProblem = null; */
     /*  this.selectedProblem = null; */
    },
    getDetailed(problem) {
      this.detailedProblem = problem;
      this.detailModalVis = true;
    },
    chooseDetail(problem) {

      this.$emit("problem-chosen", problem);
    },
    toggleJoin(problem) {
      //console.log(problem);
      // if (this.selectedRowKeys.length > 0) {
      //   this.selectedRowKeys = [];
      //   this.selectedProblem = null;
      //   this.exist = false;
      // } else {
      //this.selectedRowKeys = [problem.id];
      this.selectedProblem = problem;
      this.exist = true;
      //}
    },
    compare(problem) {
      this.selectedRowKeys = [problem.id];
      this.$emit("click-compare", problem);
    },
    getNearProblems() {
      this.similarCompLoading = true;
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "problems/nearProblems",
        params: {
          distance: this.distance,
          latitude: this.latitude,
          longitude: this.longitude,
          limit: 10,
          offset: 0,
          completed: this.completed,
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.problems = response.data.data.entities;
            this.totalCount = response.data.data.totalCount;
          } else this.$message.error(response.data.error.message);
          this.similarCompLoading = false;
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          this.similarCompLoading = false;
          console.log(err);
        });
    },
  },
  watch: {
    latitude: function () {
      this.getNearProblems();
    },
    longitude: function () {
      this.getNearProblems();
    },
    selected: function () {
      this.toggleJoin(this.selected);
    },
    totalCount: {
      immediate: true,
      handler: function (newValue) {
        this.$emit("total-count-change", newValue);
      },
    },
  },
  created() {
    this.getNearProblems();
    if (this.selected) {
      this.toggleJoin(this.selected);
    }
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
